const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDocuments = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 75 75",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M66.667,18.75l-0,39.583c-0,2.21 -0.878,4.33 -2.441,5.893c-1.563,1.563 -3.683,2.441 -5.893,2.441l0,-4.167c1.105,0 2.165,-0.439 2.947,-1.22c0.781,-0.782 1.22,-1.842 1.22,-2.947l0,-39.583l-8.333,0c-1.658,0 -3.248,-0.658 -4.42,-1.831c-1.172,-1.172 -1.83,-2.761 -1.83,-4.419l-0,-8.333l-22.917,-0c-1.105,-0 -2.165,0.439 -2.946,1.22c-0.782,0.781 -1.221,1.841 -1.221,2.946l-4.166,0c-0,-2.21 0.878,-4.329 2.44,-5.892c1.563,-1.563 3.683,-2.441 5.893,-2.441l22.917,0l18.75,18.75Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.333,66.667l0,-39.584l-18.75,-18.75l-22.916,0c-2.21,0 -4.33,0.878 -5.893,2.441c-1.563,1.563 -2.441,3.683 -2.441,5.893l0,50c0,2.21 0.878,4.329 2.441,5.892c1.563,1.563 3.683,2.441 5.893,2.441l33.333,0c2.21,0 4.33,-0.878 5.893,-2.441c1.562,-1.563 2.44,-3.682 2.44,-5.892Zm-18.75,-45.834c0,1.658 0.659,3.248 1.831,4.42c1.172,1.172 2.762,1.83 4.419,1.83l8.334,0l-0,39.584c-0,1.105 -0.439,2.165 -1.221,2.946c-0.781,0.781 -1.841,1.22 -2.946,1.22l-33.333,0c-1.105,0 -2.165,-0.439 -2.947,-1.22c-0.781,-0.781 -1.22,-1.841 -1.22,-2.946l-0,-50c-0,-1.105 0.439,-2.165 1.22,-2.947c0.782,-0.781 1.842,-1.22 2.947,-1.22l22.916,-0l0,8.333Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.833,31.25c-1.15,0 -2.083,0.933 -2.083,2.083c0,1.151 0.933,2.084 2.083,2.084l0,-4.167Zm12.5,4.167c1.151,-0 2.084,-0.933 2.084,-2.084c-0,-1.15 -0.933,-2.083 -2.084,-2.083l0,4.167Zm-12.5,-0l12.5,-0l0,-4.167l-12.5,0l0,4.167Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.833,43.75c-1.15,0 -2.083,0.933 -2.083,2.083c0,1.151 0.933,2.084 2.083,2.084l0,-4.167Zm25,4.167c1.151,-0 2.084,-0.933 2.084,-2.084c-0,-1.15 -0.933,-2.083 -2.084,-2.083l0,4.167Zm-25,-0l25,-0l0,-4.167l-25,0l0,4.167Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.833,56.25c-1.15,0 -2.083,0.933 -2.083,2.083c0,1.151 0.933,2.084 2.083,2.084l0,-4.167Zm25,4.167c1.151,-0 2.084,-0.933 2.084,-2.084c-0,-1.15 -0.933,-2.083 -2.084,-2.083l0,4.167Zm-25,-0l25,-0l0,-4.167l-25,0l0,4.167Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDocuments);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/documents.4c7ab9ddcabd343a562a1c6d3429eb27.svg";